import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IWorkPlace } from "../workPlaceModal";

export const getAllWorkPlace = createAsyncThunk(
  "WorkPlace/FindAllWorkPlaces",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/WorkPlace/FindAllWorkPlaces`,
        {
          WorkPlaceTitle: "",
        }
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching WorkPlace:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createWorkPlace = createAsyncThunk(
  "WorkPlace/InsertWorkPlace",
  async (WorkPlaceData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/WorkPlace/InsertWorkPlace`,
        WorkPlaceData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating WorkPlace:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateWorkPlace = createAsyncThunk(
  "WorkPlace/UpdateWorkPlace",
  async (WorkPlaceData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/WorkPlace/UpdateWorkPlace`,
        WorkPlaceData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating WorkPlace:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteWorkPlace = createAsyncThunk(
  "WorkPlace/DeleteWorkPlace",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/WorkPlace/DeleteWorkPlace`,
        { ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting WorkPlace :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getWorkPlaceByID = createAsyncThunk(
  "WorkPlace/FindByIDWorkPlace",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/WorkPlace/FindByIDWorkPlace`,
        { ID }
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        ServiceID: result.ServiceID ? +result.ServiceID : "",
        Title: result.Title ? result.Title : "",
        Subtitle: result.Subtitle ? result.Subtitle : "",
        Description: result.Description ? result.Description : "",
        IsActive: result.IsActive ? 1 : 2,
      } as IWorkPlace;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching WorkPlace :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllActiveWorkPlace = createAsyncThunk(
  "WorkPlace/FindAllActiveWorkPlace",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/WorkPlace/FindAllActiveWorkPlace`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching WorkPlace:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const ActiveInactiveWorkPlace = createAsyncThunk(
  "WorkPlace/ActiveInActiveWorkPlace",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/WorkPlace/ActiveInActiveWorkPlace`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive WorkPlace :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

// IMAGE UPLOAD

export const WorkPlaceDetailsImageUpload = createAsyncThunk(
  "WorkPlace/WorkPlaceImageUpdate",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/WorkPlace/WorkPlaceImageUpdate`,
        formData,
        {
          headers: { "content-type": "multipart/form-data" },
        }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error upload WorkPlace Image :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
